export const UPDATE_USER_PROFILE='UPDATE_USER_PROFILE';
export const GET_USER_DETAILS='GET_USER_DETAILS';
export const CLEAR_PASSWORD_PARAMS='CLEAR_PASSWORD_PARAMS';
export const PASSWORD_METER_PARAMS='PASSWORD_METER_PARAMS';
export const SIGN_OUT_USER="SIGN_OUT_USER";
